/**
 * Workflow Session Service
 * Workflow session management service API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { AbandonSessionRequestDto } from '../model/abandonSessionRequestDto';
// @ts-ignore
import { ExecuteByIdRequestDto } from '../model/executeByIdRequestDto';
// @ts-ignore
import { ExecuteWorkflowSessionRequestDto } from '../model/executeWorkflowSessionRequestDto';
// @ts-ignore
import { GetOrCreateSessionRequestDto } from '../model/getOrCreateSessionRequestDto';
// @ts-ignore
import { NavigateBackRequestDto } from '../model/navigateBackRequestDto';
// @ts-ignore
import { WorkflowSessionsControllerExecute200Response } from '../model/workflowSessionsControllerExecute200Response';
// @ts-ignore
import { WorkflowSessionsControllerList200Response } from '../model/workflowSessionsControllerList200Response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class WorkflowSessionsService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Abandon session
   * @param id Workflow session identifier
   * @param abandonSessionRequestDto
   */
  public async workflowSessionsControllerAbandon(id: string, abandonSessionRequestDto: AbandonSessionRequestDto, ): Promise<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling workflowSessionsControllerAbandon.');
    }
    if (abandonSessionRequestDto === null || abandonSessionRequestDto === undefined) {
      throw new Error('Required parameter abandonSessionRequestDto was null or undefined when calling workflowSessionsControllerAbandon.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/abandon`,
        data: abandonSessionRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Start new or resume workflow session via workflowKey
   * @param executeWorkflowSessionRequestDto
   */
  public async workflowSessionsControllerExecute(executeWorkflowSessionRequestDto: ExecuteWorkflowSessionRequestDto, ): Promise<WorkflowSessionsControllerExecute200Response> {
    if (executeWorkflowSessionRequestDto === null || executeWorkflowSessionRequestDto === undefined) {
      throw new Error('Required parameter executeWorkflowSessionRequestDto was null or undefined when calling workflowSessionsControllerExecute.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions/execute`,
        data: executeWorkflowSessionRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Continue existing session by ID
   * @param id Workflow session identifier
   * @param executeByIdRequestDto
   */
  public async workflowSessionsControllerExecuteById(id: string, executeByIdRequestDto: ExecuteByIdRequestDto, ): Promise<WorkflowSessionsControllerExecute200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling workflowSessionsControllerExecuteById.');
    }
    if (executeByIdRequestDto === null || executeByIdRequestDto === undefined) {
      throw new Error('Required parameter executeByIdRequestDto was null or undefined when calling workflowSessionsControllerExecuteById.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/execute`,
        data: executeByIdRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get session state
   * @param id Workflow session identifier
   * @param patientId Patient ID. If not provided, resolved from token.
   */
  public async workflowSessionsControllerGetById(id: string, patientId?: string, ): Promise<WorkflowSessionsControllerExecute200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling workflowSessionsControllerGetById.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (patientId !== undefined && patientId !== null) {
      localVarQueryParameters.append('patientId', String(patientId));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get existing active session or create new one (with initial execution)
   * @param getOrCreateSessionRequestDto
   */
  public async workflowSessionsControllerGetCurrent(getOrCreateSessionRequestDto: GetOrCreateSessionRequestDto, ): Promise<WorkflowSessionsControllerExecute200Response> {
    if (getOrCreateSessionRequestDto === null || getOrCreateSessionRequestDto === undefined) {
      throw new Error('Required parameter getOrCreateSessionRequestDto was null or undefined when calling workflowSessionsControllerGetCurrent.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions/current`,
        data: getOrCreateSessionRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List sessions with filters
   * @param workflowKey Filter by workflow key
   * @param status Filter by session status
   * @param patientId Patient ID. If not provided, resolved from token.
   * @param limit Number of items to return
   * @param offset Number of items to skip
   * @param sortBy Field to sort by
   * @param sortOrder Sort order
   */
  public async workflowSessionsControllerList(workflowKey?: string, status?: 'active' | 'completed' | 'abandoned' | 'expired' | 'failed', patientId?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: 'ASC' | 'DESC', ): Promise<WorkflowSessionsControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (workflowKey !== undefined && workflowKey !== null) {
      localVarQueryParameters.append('workflowKey', String(workflowKey));
    }
    if (status !== undefined && status !== null) {
      localVarQueryParameters.append('status', String(status));
    }
    if (patientId !== undefined && patientId !== null) {
      localVarQueryParameters.append('patientId', String(patientId));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }
    if (sortBy !== undefined && sortBy !== null) {
      localVarQueryParameters.append('sortBy', String(sortBy));
    }
    if (sortOrder !== undefined && sortOrder !== null) {
      localVarQueryParameters.append('sortOrder', String(sortOrder));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions?${queryString}` : `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Navigate backward
   * @param id Workflow session identifier
   * @param navigateBackRequestDto
   */
  public async workflowSessionsControllerNavigateBack(id: string, navigateBackRequestDto: NavigateBackRequestDto, ): Promise<WorkflowSessionsControllerExecute200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling workflowSessionsControllerNavigateBack.');
    }
    if (navigateBackRequestDto === null || navigateBackRequestDto === undefined) {
      throw new Error('Required parameter navigateBackRequestDto was null or undefined when calling workflowSessionsControllerNavigateBack.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-sessions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/back`,
        data: navigateBackRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
